// extracted by mini-css-extract-plugin
export var sliderRange = "_pp-2";
export var sliderRoot = "_pp-0";
export var sliderThumb = "_pp-3";
export var sliderTrack = "_pp-1";